module.exports = __webpack_public_path__ + "static/Streams@final-2edd7bcd11ab691da6fc86e1c0bb5d0d.png";